module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Medium_1.4228720d.ttf";